import { createClient, SupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Supabase URL or anon key is not set in env');
}

export const supabase: SupabaseClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
  // shared / field スキーマも参照可能に
  db: { schema: 'public' },
});

/**
 * shared スキーマのクライアントを返す
 */
export const sharedDb = () => supabase.schema('shared');
export const fieldDb = () => supabase.schema('field');
export const accountingDb = () => supabase.schema('accounting');
